var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icones/User/User,Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 31.2436C13.115 28.7019 16.6533 27.1386 20.5383 27.1386C24.385 27.1386 27.885 28.6703 30.5 31.1653C27.885 33.7069 24.3467 35.2703 20.4617 35.2703C16.615 35.2703 13.115 33.7386 10.5 31.2436Z",
    stroke: "#00B26B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.125 26.9786C6.10833 24.9553 5.5 22.6903 5.5 20.2703C5.5 11.9803 12.21 5.27026 20.5 5.27026C28.79 5.27026 35.5 11.9803 35.5 20.2703C35.5 22.6869 34.895 24.9536 33.8717 26.9753",
    stroke: "#00B26B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M24.0355 13.4014C25.9881 15.354 25.9881 18.5199 24.0355 20.4725C22.0829 22.4251 18.9171 22.4251 16.9645 20.4725C15.0118 18.5199 15.0118 15.354 16.9645 13.4014C18.9171 11.4488 22.0829 11.4488 24.0355 13.4014",
    stroke: "#00B26B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.3bbbad7a3d7234f551fb9df11f0127f6.svg";
export { ForwardRef as ReactComponent };